<button
  class="button_blue"
  [taxOpenCertificateModal]="{ data: data, title: 'certificate.title' }"
  (signatureGenerated)="signatureGenerated.emit($event)"
  translate
>
  {{ data?.type === 'REG' ? 'registration.cert.choose' : 'registration.cert.enter' }}
</button>

<div class="certificate-description">
  {{
    (data?.type === 'REG' ? 'registration.cert.description' : 'registration.cert.help') | translate
  }}
</div>

<svg-icon key="certificate"></svg-icon>

<div>
  <div class="blue-grey-text">
    <a href="https://pki.gov.kz/ncalayer/" target="_blank" class="blue-grey-text__link" translate
      >registration.nca.warning</a
    >
    <p class="blue-grey-text__description" translate>registration.nca.warning2</p>
  </div>

  <div class="blue-grey-text">
    <a
      href="https://egov.kz/cms/ru/services/pass_onlineecp"
      target="_blank"
      class="blue-grey-text__link"
      translate
      >registration.nca.sign</a
    >
    <p class="blue-grey-text__description" translate>registration.nca.sign2</p>
  </div>
</div>
